import React from 'react';
import CourseComparison from '../components/career/CourseComparison';

const CourseComparisonPage = () => {
  return <CourseComparison />;
};

export default CourseComparisonPage;
